var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-bottom-sheet',{ref:"sheet",staticClass:"sheet prioritized-sheet",attrs:{"type":"header","title":_vm.title,"no-layout":""}},[_c('address-search',_vm._g(_vm._b({ref:"addressSearch",staticClass:"span-6",on:{"input":_vm.onInput,"select":_vm.onSelect,"error":_vm.onError}},'address-search',_vm.$attrs,false),_vm.componentListeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }